import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import '../../styles.css';

import { Button, TextInput } from '@components';

import { Field, Formik } from 'formik';
import { object, string } from 'yup';

import { APIAutenticacao } from '../../../../common/services/autenticacao';

import { setRecuperacaoSenhaDados } from '../../../../store/configs/slice';

export const InsereMatricula = () => {
  const [matriculaInvalida, setMatriculaInvalida] = useState('');
  const dispatch = useDispatch();

  const submitMatricula = async (values) => {
    const response = await APIAutenticacao.verificaResetEspecial(
      values.matricula
    );

    if (!response) {
      const dadosUsuario = await APIAutenticacao.recuperaSenha(
        values.matricula
      );

      if (dadosUsuario.data[0].linhasafetadas === 0) {
        setMatriculaInvalida('Matrícula inválida!');
        return;
      }

      const params = {
        email: dadosUsuario.data[0].email,
        telefone: dadosUsuario.data[0].telefone,
        matricula: values.matricula,
        token: '',
        etapa: '2',
      };
      dispatch(setRecuperacaoSenhaDados(params));
    } else {
      dispatch(
        setRecuperacaoSenhaDados({
          email: '',
          telefone: '',
          matricula: values.matricula,
          token: '',
          etapa: '2',
        })
      );
    }
  };

  const matriculaSchema = object({
    matricula: string().required('A matricula é obrigatória'),
  });

  return (
    <Formik
      enableReinitialize
      initialValues={{
        matricula: '',
      }}
      validationSchema={matriculaSchema}
      onSubmit={async (values, { setSubmitting }) => {
        await submitMatricula(values);
        setSubmitting(false);
      }}
    >
      {({ handleSubmit, isSubmitting, isValid }) => (
        <form onSubmit={handleSubmit}>
          <Field
            className="mb-3"
            name="matricula"
            large
            component={TextInput}
            label="Matrícula"
          />
          <p className="d-block text-center mt-32 ts-14 fw-bold text-red">
            {matriculaInvalida}
          </p>
          <Button
            className="mt-32 ts-14"
            large
            disabled={isSubmitting || !isValid}
            onClick={handleSubmit}
          >
            Enviar
          </Button>
        </form>
      )}
    </Formik>
  );
};
